(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('BlockedTimeReason', BlockedTimeReason);

    BlockedTimeReason.$inject = ['$resource'];

    function BlockedTimeReason ($resource) {
        var resourceUrl =  'api/blocked-time-reasons/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
